import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import LessonCard from '../../lesson-card/lesson-card';
import CourseCard from '../../course-card/course-card';
import CollectionCard from '../../collection-card/collection-card';
import AssessmentCard from '../../assessment-card/assessment-card';
import ResourceCard from '../../resource-card/resource-card';
import QuestionCard from '../../question-card/question-card';
import UnitCard from '../../unit-card/unit-card';

@Component({
    name: 'pull-out-more-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'lesson': LessonCard,
        'course': CourseCard,
        'collection': CollectionCard,
        'assessment': AssessmentCard,
        'resource': ResourceCard,
        'question': QuestionCard,
        'unit': UnitCard,
    },
})

export default class PullOutMoreCard extends Vue {

    // --------------------------------------------------------------
    // Properties

    @Prop()
    private pullOutContents: any;

    private get contentTypes() {
        return Object.keys(this.pullOutContents);
    }

    // --------------------------------------------------------------------
    // Methods
    private contentBind(content: any, item: any) {
        const bind: any = {};
        if (this.contentTypes) {
            bind[item] = content;
        }

        return bind;
    }

    private loadComponent(type: string) {
        if (type === 'signatureCollection') {
            type = 'collection';
        } else if (type === 'signatureAssessment') {
            type = 'assessment';
        }
        return type;
    }

}
